import React, {useEffect, useMemo, useRef, useState} from "react";
import {
    FiltersRow,
    FilterSelectWrap,
    PlayersTable,
    TableContainer,
} from './DraftRoomStimulyatorPart.styles';
import Select from "react-select";
import {useSelector} from "react-redux";
import {selectStimulyatorDrafRoom} from "../../app/features/stimulyatorDraftRoom/stimulyatorDraftRoomSlice";
import {POSITIONS_COLOR} from "../../utils/constants";


function DraftRoomStimulyatorPart(props){


    const {teamDraftPlayerChoose, totalRounds }=useSelector(selectStimulyatorDrafRoom);
    console.log(teamDraftPlayerChoose, 66)
    const tableRef = useRef(null);
    const round=props?.round
    const chosenTeam=props?.chosenTeam

    const [selectedTeamId, setSelectedTeamId] = useState("all");
    const [selectedPosition, setSelectedPosition] = useState("all");

    const isFiltering = selectedTeamId !== "all" || selectedPosition !== "all";

    const teamOptions = useMemo(() => {
        const seen = new Set();
        return teamDraftPlayerChoose.reduce((acc, team) => {
            const id = String(team.id);
            if (!seen.has(id)) {
                seen.add(id);
                acc.push({ id, name: team.name, logo: team.logo });
            }
            return acc;
        }, []);
    }, [teamDraftPlayerChoose]);

    const picks = useMemo(() => {
        const roundsCount = Number(round) || 0;
        const list = [];
        for (let roundIndex = 0; roundIndex < roundsCount; roundIndex++) {
            for (let teamIndex = 0; teamIndex < teamDraftPlayerChoose.length; teamIndex++) {
                const team = teamDraftPlayerChoose[teamIndex];
                const player = team.choosePlayers?.[roundIndex] || null;
                list.push({ roundIndex, teamIndex, team, player });
            }
        }
        return list;
    }, [teamDraftPlayerChoose, round]);

    const positionOptions = useMemo(() => {
        const seen = new Set();
        picks.forEach((pick) => {
            const position = pick.player?.position;
            if (position) {
                seen.add(position);
            }
        });
        return Array.from(seen);
    }, [picks]);

    const teamSelectOptions = useMemo(() => {
        return [
            { value: "all", label: "All Teams" },
            ...teamOptions.map((team) => ({
                value: team.id,
                label: team.name,
                logo: team.logo,
            })),
        ];
    }, [teamOptions]);

    const selectedTeamOption = useMemo(() => {
        return teamSelectOptions.find((option) => option.value === selectedTeamId) || teamSelectOptions[0];
    }, [teamSelectOptions, selectedTeamId]);

    const positionSelectOptions = useMemo(() => {
        return [
            { value: "all", label: "All Positions", color: POSITIONS_COLOR.All || "" },
            ...positionOptions.map((position) => ({
                value: position,
                label: position,
                color: POSITIONS_COLOR[position] || "",
            })),
        ];
    }, [positionOptions]);

    const selectedPositionOption = useMemo(() => {
        return positionSelectOptions.find((option) => option.value === selectedPosition) || positionSelectOptions[0];
    }, [positionSelectOptions, selectedPosition]);

    const selectStyles = useMemo(() => ({
        control: (base) => ({
            ...base,
            minHeight: 32,
            borderColor: "#E9EBEF",
            boxShadow: "none",
            fontFamily: "'Saira Semi Condensed', sans-serif",
            fontSize: 14,
        }),
        valueContainer: (base) => ({
            ...base,
            padding: "0 8px",
        }),
        input: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
        }),
        indicatorsContainer: (base) => ({
            ...base,
            height: 32,
        }),
        menu: (base) => ({
            ...base,
            zIndex: 3,
        }),
    }), []);

    const filteredPicks = useMemo(() => {
        if (!isFiltering) {
            return picks;
        }
        return picks.filter((pick) => {
            if (!pick.player) {
                return false;
            }
            if (selectedTeamId !== "all" && String(pick.team.id) !== selectedTeamId) {
                return false;
            }
            if (selectedPosition !== "all") {
                const position = pick.player?.position || "";
                if (position.toLowerCase() !== selectedPosition.toLowerCase()) {
                    return false;
                }
            }
            return true;
        });
    }, [isFiltering, picks, selectedPosition, selectedTeamId]);

    const picksByRound = useMemo(() => {
        const roundsCount = Number(round) || 0;
        const grouped = Array.from({ length: roundsCount }, () => []);
        filteredPicks.forEach((pick) => {
            if (pick.roundIndex < roundsCount) {
                grouped[pick.roundIndex].push(pick);
            }
        });
        return grouped;
    }, [filteredPicks, round]);

    const latestSelection = useMemo(() => {
        let latest = null;
        const maxRounds = teamDraftPlayerChoose.reduce((max, team) => {
            return Math.max(max, team.choosePlayers?.length || 0);
        }, 0);

        for (let roundIndex = 0; roundIndex < maxRounds; roundIndex++) {
            for (let teamIndex = 0; teamIndex < teamDraftPlayerChoose.length; teamIndex++) {
                const team = teamDraftPlayerChoose[teamIndex];
                const player = team.choosePlayers?.[roundIndex] || null;
                if (player) {
                    latest = { team, player, roundIndex, teamIndex };
                }
            }
        }

        return latest;
    }, [teamDraftPlayerChoose]);

    const latestMatchesFilters = useMemo(() => {
        if (!latestSelection) {
            return false;
        }
        if (!isFiltering) {
            return true;
        }
        if (selectedTeamId !== "all" && String(latestSelection.team.id) !== selectedTeamId) {
            return false;
        }
        if (selectedPosition !== "all") {
            const position = latestSelection.player?.position || "";
            if (position.toLowerCase() !== selectedPosition.toLowerCase()) {
                return false;
            }
        }
        return true;
    }, [isFiltering, latestSelection, selectedPosition, selectedTeamId]);

    const latestKey = useMemo(() => {
        if (!latestSelection) {
            return null;
        }

        return [
            latestSelection.roundIndex,
            latestSelection.team.id,
            latestSelection.player?.player,
            latestSelection.player?.position,
            latestSelection.player?.college,
        ].join("|");
    }, [latestSelection]);

    const latestKeyRef = useRef(latestKey);
    const latestTimerRef = useRef(null);
    const [showLatest, setShowLatest] = useState(false);

    useEffect(() => {
        latestKeyRef.current = latestKey;
    }, [latestKey]);

    useEffect(() => {
        if (latestTimerRef.current) {
            clearTimeout(latestTimerRef.current);
            latestTimerRef.current = null;
        }

        if (!latestSelection) {
            setShowLatest(false);
            return;
        }

        setShowLatest(true);
        const keyAtStart = latestKey;
        latestTimerRef.current = setTimeout(() => {
            if (latestKeyRef.current === keyAtStart) {
                setShowLatest(false);
            }
        }, 5000);

        return () => {
            if (latestTimerRef.current) {
                clearTimeout(latestTimerRef.current);
                latestTimerRef.current = null;
            }
        };
    }, [latestKey, latestSelection]);

    const showEmptyState = isFiltering && filteredPicks.length === 0 && !(showLatest && latestMatchesFilters);

    useEffect(() => {
        const nextRoundElement = tableRef.current?.querySelector(`[data-round="${round}"]`);
        if (nextRoundElement) {
            nextRoundElement.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [round]);

    return(
        <div>
            <FiltersRow>
                <FilterSelectWrap>
                    <Select
                        inputId="overall-picks-team-filter"
                        aria-label="Filter by team"
                        value={selectedTeamOption}
                        options={teamSelectOptions}
                        isSearchable={false}
                        onChange={(option) => setSelectedTeamId(option ? option.value : "all")}
                        styles={selectStyles}
                        formatOptionLabel={(option) => (
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                {option.logo && (
                                    <img
                                        src={option.logo}
                                        alt={option.label}
                                        style={{ width: 20, height: 20 }}
                                    />
                                )}
                                <span>{option.label}</span>
                            </div>
                        )}
                    />
                </FilterSelectWrap>
                <FilterSelectWrap>
                    <Select
                        inputId="overall-picks-position-filter"
                        aria-label="Filter by position"
                        value={selectedPositionOption}
                        options={positionSelectOptions}
                        isSearchable={false}
                        onChange={(option) => setSelectedPosition(option ? option.value : "all")}
                        styles={selectStyles}
                        formatOptionLabel={(option) => (
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                {option.color ? (
                                    <span
                                        aria-hidden="true"
                                        style={{
                                            width: 12,
                                            height: 12,
                                            borderRadius: "50%",
                                            backgroundColor: option.color,
                                            display: "inline-block",
                                        }}
                                    />
                                ) : null}
                                <span>{option.label}</span>
                            </div>
                        )}
                    />
                </FilterSelectWrap>
            </FiltersRow>
            <TableContainer>
                <PlayersTable ref={tableRef}>
                    <thead>
                    <tr>
                        <th>Pick</th>
                        <th>Team</th>
                        <th>Player</th>
                        <th>Pos</th>
                        <th>School</th>
                    </tr>
                    </thead>
                    <tbody>
                    {latestSelection && showLatest && latestMatchesFilters && (
                        <React.Fragment>
                            <tr className="round-header">
                                <td colSpan="5">{`Latest (Round ${latestSelection.roundIndex + 1})`}</td>
                            </tr>
                            <tr
                                key={`new-${latestSelection.roundIndex}-${latestSelection.team.id}`}
                                data-round={latestSelection.roundIndex + 1}
                            >
                                <td>{`${latestSelection.roundIndex + 1}.${latestSelection.teamIndex + 1}`}</td>
                                <td>
                                    <img
                                        src={latestSelection.team.logo}
                                        alt={latestSelection.team.name}
                                        style={{
                                            width: "40px",
                                            height: "40px",
                                            borderRadius: "50%",
                                        }}
                                    />
                                </td>
                                <td>{latestSelection.player ? latestSelection.player.player : "-"}</td>
                                <td>{latestSelection.player ? latestSelection.player.position : "-"}</td>
                                <td>{latestSelection.player ? latestSelection.player.college : "-"}</td>
                            </tr>
                        </React.Fragment>
                    )}
                    {showEmptyState && (
                        <tr>
                            <td className="empty-state" colSpan="5">No picks match these filters.</td>
                        </tr>
                    )}
                    {/*{Array.from({ length: totalRounds }).map((_, roundIndex) => {*/}
                    {picksByRound.map((roundPicks, roundIndex) => {
                        if (isFiltering && roundPicks.length === 0) {
                            return null;
                        }
                        const currentRound = roundIndex + 1;
                        return (
                            <React.Fragment key={currentRound}>
                                <tr className="round-header">
                                    <td colSpan="5">Round {currentRound}</td>
                                </tr>

                                {roundPicks.map((pick) => {
                                    const player = pick.player || null;
                                    console.log(pick.team.name, player)
                                    return (
                                        <tr
                                            key={`${currentRound}-${pick.team.id}`}
                                            data-round={currentRound}
                                        >
                                            <td>{`${currentRound}.${pick.teamIndex + 1}`}</td>
                                            <td>
                                                <img
                                                    src={pick.team.logo}
                                                    alt={pick.team.name}
                                                    style={{
                                                        width: "40px",
                                                        height: "40px",
                                                        borderRadius: "50%",
                                                    }}
                                                />
                                            </td>
                                            <td>{player ? player.player : "-"}</td>
                                            <td>{player ? player.position : "-"}</td>
                                            <td>{player ? player.college : "-"}</td>
                                        </tr>
                                    );
                                })}
                            </React.Fragment>
                        );
                    })}
                    </tbody>
                </PlayersTable>
            </TableContainer>
        </div>

    )
}

export default DraftRoomStimulyatorPart;
